import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";
import {dataRegister} from "../../services/dataRegister";

class SignupAdsFacebook extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            learn_more: false,
            quotes: null,
            market: null,
            image: null,
            tips: [],
            industry: {},
            customIndustry: null,
            available: false
        };
    };

    componentDidMount() {
        this._updateData();
    }

    _updateData() {
        this.setState({
            tips: [
                {title: this._renderText("item_42")},
                {title: this._renderText("item_43")},
                {title: this._renderText("item_44")},
                {title: this._renderText("item_45")},
                {title: this._renderText("item_46")},
                {title: this._renderText("item_47")}
            ],
            selected: this.props.setChannel,
            quotes: this.props.setQuotes,
            industry: this.props.setIndustry,
            customIndustry: this.props.setCustomIndustry,
            image: this.props.setImage,
            market: salesChannelRegister.get("market"),
            available: this.props.setAvailable
        });
    }

    /*
    _placement(){
        try{
            let query = {
                industry: this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: this._renderQuotes(),
                website: this._renderText("item_60") + salesChannelRegister.get("market"),
                image: this.state.image.url,
                saleschannel: "adbop"
            };
            const stringified = queryString.stringify(query);
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/facebook?" + stringified, '_blank');
        }catch (e) {
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/facebook", '_blank');
        }
    }
    */

    _placement(){
        try{
            let query = {
                industry: this.state.customIndustry?this.state.customIndustry:this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: this._renderQuotes(),
                website: this._renderText("item_60") + salesChannelRegister.get("market"),
                //image: this.state.image.id === "uploaded_image"?"uploaded_image":this.state.image.url,
                saleschannel: 'adbop'
            };

            try{
                if(this.state.image.url && this.state.image.id !== "uploaded_image"){
                    query.image = this.state.image.url;
                }
            }catch (e) {}

            /*
            if(this.state.image.id === "uploaded_image"){
                query.image = this.state.image.web_url?this.state.image.web_url:"uploaded_image";
            }else{
                query.image = this.state.image.url;
            }
            */

            const stringified = queryString.stringify(query);
            let url = 'https://placement.'+dataRegister.domain;
            //let url = 'http://localhost:3001';
            var popUp = window.open(url +"/"+langRegister.lang()+"/facebook?" + stringified, '_blank');
            if(this.state.image.data_url){
                setTimeout(() => {
                    popUp.postMessage(this.state.image.data_url, url);
                }, 500)
            }

        }catch (e) {
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/facebook", '_blank');
        }
    }

    /*
    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                for (let key in this.state.quotes) {
                    quotes_string += this.state.quotes[key].slogan + (Object.keys(this.state.quotes).length > i ? " - " : "");
                    i++;
                }
            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }
    */

    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in this.state.quotes) {
                    sortable.push([this.state.quotes[key], this.state.quotes[key].index]);
                }
                sortable.sort(function(a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });
            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }

    _renderAdImage() {
        if (this.state.image) {
            return (
                <div className={Styles.imagesContainerItem}>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            !this.state.image.file &&
                            <img src={this.state.image.url}/>
                        }
                        {
                            this.state.image.file &&
                            <div style={{backgroundImage: "url(" + this.state.image.url + ")"}} className={Styles.imagesContainerItemInnerUploadImage}/>
                        }
                    </div>
                </div>
            )
        }
    }

    _renderIndustry(){
        if(this.state.customIndustry){
            return this.state.customIndustry;
        }else{
            return this.state.industry.name;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerLeftItem}>
                {
                    this.state.selected && this.state.available &&
                    <div onClick={() => this._placement()} className={Styles.contentContainerLeftItemPlacement}>
                        <img src={require("../../assets/images/plus_sign_white_small.png")} className={Styles.contentContainerLeftItemPlacementIcon}/>
                    </div>
                }
                <div className={
                         cx(Styles.contentContainerLeftItemInner,
                             {
                                 [Styles.contentContainerLeftItemInnerActive]: !this.state.selected,
                             })
                     }>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemInnerOverlay,
                                {
                                    [Styles.contentContainerLeftItemInnerOverlayActive]: !this.state.selected,
                                })
                        }
                    >
                        {
                            !this.state.selected &&
                            <div onClick={() => {
                                if (this.state.available) {
                                    this.props.selectChannel("facebook");
                                    this.setState({selected: !this.state.selected})
                                }
                            }}
                                 className={
                                     cx(Styles.contentContainerLeftItemInnerOverlayButton,
                                         {
                                             [Styles.contentContainerLeftItemInnerOverlayButtonDisabled]: !this.state.available,
                                         })
                                 }>
                                {
                                    this.state.available &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.available &&
                                    this._renderText("item_65")
                                }
                            </div>
                        }
                        <div className={Styles.contentContainerLeftItemInnerOverlayTitle}>
                            Facebook <span className={Styles.contentContainerLeftItemInnerOverlayTitleSmall}>social ads</span>
                        </div>
                        {
                            this.state.tips.filter((item, key) => {
                                return !this.state.learn_more && key < 3 || this.state.learn_more && key > 2
                            }).map((prop, i) => {
                                return (
                                    <div key={i}
                                         className={Styles.contentContainerLeftItemInnerOverlayItem}>
                                        &#x2b; {prop.title}
                                    </div>
                                )
                            })
                        }
                        <div onClick={() => {this.setState({learn_more: !this.state.learn_more})}} className={Styles.contentContainerLeftItemInnerOverlayReadMore}>
                            {
                                this.state.learn_more &&
                                <span>{this._renderText("item_28")}</span>
                            }
                            {
                                !this.state.learn_more &&
                                <span>{this._renderText("item_29")}</span>
                            }
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftItemFacebookInnerTop}>
                        <div className={Styles.contentContainerLeftItemFacebookInnerTopIcon}>
                            <img
                                className={Styles.contentContainerLeftItemFacebookInnerTopIconLogo}
                                src={require("../../assets/images/adbop_logo_small_new.svg")}/>
                        </div>
                        <div
                            className={Styles.contentContainerLeftItemFacebookSponsorContainer}>
                            <div
                                className={Styles.contentContainerLeftItemFacebookSponsorContainerName}>
                                adBop
                            </div>
                            <div
                                className={Styles.contentContainerLeftItemFacebookSponsorContainerText}>
                                <div>{this._renderText("item_13")} •</div>
                                <img src={require("../../assets/images/globe.svg")}
                                     className={Styles.contentContainerLeftItemFacebookSponsorContainerTextGlobe}/>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftFacebookItemAdText}>
                        {this._renderQuotes()}
                    </div>
                    {this._renderAdImage()}
                    <div className={Styles.contentContainerLeftFacebookItemAdLink}>
                        {this._renderText("item_60")}{this.state.market}
                    </div>
                    <div className={Styles.contentContainerLeftFacebookItemAdIndustry}>
                        {this._renderIndustry()}
                    </div>
                </div>
                {
                    <div className={Styles.contentContainerLeftItemBottom}>
                        <div
                            className={
                                cx(Styles.contentContainerLeftItemBottomIconContainer,
                                    {
                                        [Styles.contentContainerLeftItemBottomIconContainerActive]: this.state.selected,
                                    })
                            }
                        >
                            <img
                                className={Styles.contentContainerLeftItemBottomIconContainerIconFb}
                                src={require("../../assets/images/facebook_logo_icon.svg")}/>
                        </div>
                        {
                            !this.state.selected &&  this.state.available &&
                            <img onClick={() => {this.props.selectChannel("facebook"); this.setState({selected: !this.state.selected})}}
                                 className={Styles.contentContainerLeftItemBottomSlider}
                                 src={require("../../assets/images/slider_deactive.svg")}/>
                        }
                        {
                            this.state.selected &&  this.state.available &&
                            <img onClick={() => {this.props.selectChannel("facebook"); this.setState({selected: !this.state.selected})}}
                                 className={Styles.contentContainerLeftItemBottomSlider}
                                 src={require("../../assets/images/slider_active.svg")}/>
                        }
                        {
                            !this.state.selected &&
                            <div className={Styles.contentContainerLeftItemBottomDots}>
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomDotsItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomDotsItemActive]: !this.state.learn_more,
                                        })
                                }/>
                                <div className={Styles.contentContainerLeftItemBottomDotsItemLine}/>
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomDotsItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomDotsItemActive]: this.state.learn_more,
                                        })
                                }/>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default SignupAdsFacebook;


// WEBPACK FOOTER //
// ./src/components/signup-ads-facebook/component.js